// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2gRpm","inputWrap":"CustomTip_inputWrap__3f6Lj"};